import { IAnnotationConfig } from '@indices/def';
import * as D from '../../def';
export const annotation:D.IAnnotation = {
  circle: {
    pricePoints: [
      {
        color: 'red',
        date: {
          year: 2011,
          month: 6,
          day: 13,
        },
      },
      {
        color: 'green',
        date: {
          year: 2012,
          month: 7,
          day: 5,
        },
      },
      {
        color: 'red',
        date: {
          year: 2013,
          month: 12,
          day: 4,
        },
      },
      {
        color: 'green',
        date: {
          year: 2015,
          month: 4,
          day: 28,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 12,
          day: 17,
        },
      },
      {
        color: 'green',
        date: {
          year: 2019,
          month: 2,
          day: 8,
        },
      },
    ],
    IndicePoints: [
      {
        color: 'red',
        date: {
          year: 2011,
          month: 6,
          day: 13,
        },
      },
      {
        color: 'green',
        date: {
          year: 2012,
          month: 7,
          day: 5,
        },
      },
      {
        color: 'red',
        date: {
          year: 2013,
          month: 12,
          day: 4,
        },
      },
      {
        color: 'green',
        date: {
          year: 2015,
          month: 4,
          day: 28,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 12,
          day: 17,
        },
      },
      {
        color: 'green',
        date: {
          year: 2019,
          month: 2,
          day: 8,
        },
      },
    ],
  },
};
